"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

var _default = {
  mixins: [(0, _crud.crud)()],
  props: {
    data: {
      type: Object,
      required: true
    },
    permission: {
      type: Object,
      required: true
    },
    disabledEdit: {
      type: Boolean,
      default: false
    },
    disabledDle: {
      type: Boolean,
      default: false
    },
    msg: {
      type: String,
      default: '确定删除本条数据吗？'
    }
  },
  data: function data() {
    return {
      pop: false
    };
  },
  methods: (_methods = {
    doCancel: function doCancel() {
      this.pop = false;
      this.crud.cancelDelete(this.data);
    },
    toDelete: function toDelete() {
      this.pop = true;
    }
  }, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterDelete, function (crud, data) {
    if (data === this.data) {
      this.pop = false;
    }
  }), (0, _defineProperty2.default)(_methods, "onPopoverShow", function onPopoverShow() {
    var _this = this;

    setTimeout(function () {
      document.addEventListener('click', _this.handleDocumentClick);
    }, 0);
  }), (0, _defineProperty2.default)(_methods, "onPopoverHide", function onPopoverHide() {
    document.removeEventListener('click', this.handleDocumentClick);
  }), (0, _defineProperty2.default)(_methods, "handleDocumentClick", function handleDocumentClick(event) {
    this.pop = false;
  }), _methods)
};
exports.default = _default;